import { availableLocales } from 'models/localization';
import _cloneDeep from 'lodash/cloneDeep';
import findAvailableLocale from './findAvailableLocale';

const findAvailableLocaleByKeys = (obj: Record<string, any> = {}, locale: string, keys: string[]) => {
  const val = _cloneDeep(findAvailableLocale(obj, locale));
  keys.forEach((key) => {
    let localeIdx = 0;
    while (!val[key] && localeIdx < availableLocales.length) {
      val[key] = obj?.[availableLocales[localeIdx]]?.[key];
      localeIdx += 1;
    }
  });
  return val;
};
export default findAvailableLocaleByKeys;
